<!-- HERO -->

<section
  class="home-hero"
  [style.background-image]="'url(' + settings?.heroImageUrl + ')'">

  <div class="home-hero-left">

    <h1>
      {{ settings?.heroTitle }}

      <span>
        {{ settings?.heroSubtitle }}
      </span>
    </h1>

    <p>
      {{ settings?.heroDescription }}
    </p>
  </div>

  <section class="features-bar">

    <div class="feature-item">
      <i class="fa-solid fa-layer-group"></i>
      <div>
        <h4>KVALITETNI</h4>
        <span>MATERIJALI</span>
      </div>
    </div>

    <div class="feature-item">
      <i class="fa-solid fa-shirt"></i>
      <div>
        <h4>DIZAJN</h4>
        <span>PO VAŠOJ MERI</span>
      </div>
    </div>

    <div class="feature-item">
      <i class="fa-solid fa-pen-ruler"></i>
      <div>
        <h4>POTPUNA</h4>
        <span>PERSONALIZACIJA</span>
      </div>
    </div>

    <div class="feature-item">
      <i class="fa-solid fa-truck"></i>
      <div>
        <h4>POUZDANA</h4>
        <span>ISPORUKA</span>
      </div>
    </div>

  </section>

</section>

<!-- KATEGORIJE -->

<section
  id="katalog"
  class="categories-section">

  <div class="section-header">

    <h2>
      NAŠI PROIZVODI
    </h2>
<div class="section-description">
    <p>
  Od sportskih dresova i opreme za trening do personalizovane odeće i dodatne opreme, svaki proizvod izrađujemo prema vašim potrebama.
  <br>
  Pogledajte naše modele, podelite svoju ideju ili je razvijte uz našu pomoć i kreirajte opremu za svoj tim, kompaniju ili brend.
    </p>
</div>
  </div>

</section>

<section class="categories-grid">

  <a
    *ngFor="let category of categories"
    class="category-card"
    [routerLink]="['/category', category.slug]">

    <img
      [src]="category.image || 'assets/images/no-image.jpg'"
      [alt]="category.name">

    <div class="card-overlay">

      <h3>
        {{ category.name }}
      </h3>

      <div class="card-footer">

        <span class="count">
          Pogledaj više
        </span>
      </div>

    </div>

  </a>

</section>
<section class="partners-section">
  <h2>Naši partneri</h2>

  
</section>
<section class="cta-section">

  <div class="cta-content">

    <h2>
      KRENIMO OD      
      <span>
         VAŠE IDEJE
      </span>
    </h2>

    <p>
      Bilo da želite da prilagodite jedan od naših modela ili kreirate potpuno novi dizajn, naš tim će vam pomoći da svaku ideju pretvorite u gotov proizvod.
    </p>

    <a
        routerLink="/contact"
        class="btn-main">

        KONTAKTIRAJTE  NAS

    </a>

  </div>

</section>
